import { useEffect, useRef } from "react";
import { useDispatch } from 'react-redux';

import { setStateScrolling } from "../../../../../actions/index";

const useListScroll = () => {
  const dispatch = useDispatch();
  let ref = useRef(null);
  const onScroll = (e) => {
    if (e.currentTarget.firstChild && ref && ref.current) {
      dispatch(setStateScrolling((e.currentTarget.firstChild.getBoundingClientRect().y < ref.current.getBoundingClientRect().y)));
    } 
  }
  useEffect(() => {
    return () => { dispatch(setStateScrolling(false)); }
  }, [dispatch])

  return { ref, onScroll };
};

export default useListScroll;
